import { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { doApiCall } from "./utils";

const { REACT_APP_MEMBER_PORTAL_ENDPOINT_URL } = process.env;

export interface FormAnswer {
  questionId: string;
  title: string;
  value: string | boolean | string[];
  text: string | string[];
  questionAsAsked: any;
}

export interface FormTemplate {
  id: string;
  title: string;
  description: string;
  content: string;
  version: string;
}

export interface FormSubmission {
  id: string;
  formInfo: FormTemplate;
  formAnswers: FormAnswer[];
  submittedOn: number;
  version: string;
}

export interface GetFormTemplatesResponse {
  data: {
    forms: FormTemplate[];
  };
  meta: {
    message?: string;
  };
}

export interface GetFormSubmissionsResponse {
  data: {
    submissions: FormSubmission[];
  };
  meta: object;
}

export interface PostFormSubmissionPayload {
  formId: string;
  formAnswers: FormAnswer[];
}

export const getFormTemplates = (): Promise<
  AxiosResponse<GetFormTemplatesResponse> | AxiosError
> => {
  const request: AxiosRequestConfig = {
    method: "GET",
    url: `https://${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}/form-templates`
  };

  return doApiCall(request);
};

export const getFormSubmissions = (): Promise<
  AxiosResponse<GetFormSubmissionsResponse> | AxiosError
> => {
  const request: AxiosRequestConfig = {
    method: "GET",
    url: `https://${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}/member/form-submissions`
  };

  return doApiCall(request);
};

export const postFormSubmission = (
  payload: PostFormSubmissionPayload
): Promise<AxiosResponse<FormSubmission> | AxiosError> => {
  const request: AxiosRequestConfig = {
    method: "POST",
    url: `https://${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}/member/form-submissions`,
    data: payload
  };

  return doApiCall(request);
};
